import React from 'react'

// a wrapper for labelling and displaying data elements in a grid
export default ({ label, children }: { label: any; children: any }) => (
  <div>
    <div className="awsui-util-label">{label}</div>
    <div>{children}</div>
  </div>
)
